/* eslint-disable valid-typeof */
/* eslint-disable no-fallthrough */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable no-return-assign */
/* eslint-disable operator-linebreak */
import { mapState } from 'vuex';
import orderList from "../order-grid/OrderList.vue";
// import medicinesList from "../MedicineList";
import orderDetailList from "../orderDetailList";
import serviceOrder from "../../services/orders/OrderService.js";
import serviceProvider from "../../services/provider/ProviderService.js";
import locationService from "../../services/location/LocationService";
import serviceDocument from "../../services/patient/DocumentService.js";
import servicePatient from "../../services/patient/PatientService";
import {
    StorageService
} from "../../services/StorageService";
import incomeGroupService from "../../services/patient/IncomeGroupService";
import patientList from "./patient-list/PatientList.vue";
import serviceCalendar from "../../services/calendar/serviceCalendar";
import i18n from "../../i18n/index";
import {
    Money
} from "v-money";
import dayjs from "dayjs";
import orderDetailsService from "../../services/orderDetail/orderDetailsService.js";
import schedulingAppointment from "./schedulingAppointmet/schedulingAppointment.vue";
import serviceForceShippingFee from "../../services/force-shipping-fee/ForceShippingFeeService";
const holidaysApi = require("colombia-holidays");


export default {
    props: ["status", "enabledColumns"],
    components: {
        orderList,
        // medicinesList,
        orderDetailList,
        Money,
        patientList,
        schedulingAppointment
    },
    props: {
        isSpoiled: {
            type: Boolean,
            default: () => {}
        }
    },
    data() {
        return {
            imagenn: false,
            encabezados: [
                { text: 'ESTADO', value: 'estado' },
                { text: 'FECHA', value: 'fecha' },
                { text: 'MOTIVO', value: 'motivo' },
            ],
            campos: [],
            testFile: null,
            dialog: false,
            authorizationsLoaded: false,
            menuDelivery: false,
            menuPreviewDelivered: false,
            date_previewDelivered: "",
            datePreviewDelivery: "",
            rules: {
                required: value => !!value || "El campo es requerido"
            },
            checked: "",
            validFormPatient: false,
            validFormOrderDetailList: false,
            validFormNotes: false,
            validFormOrder: false,
            selectOrderCode: "",
            paginationn: {},
            isFeatured: false,
            isApplicable: false,
            isWatched: false,
            orderTable: {
                searchItems: 0,
                searchTerm: ""
            },
            patient: {
                id: "",
                documentType: "",
                document: "",
                fullname: "",
                address: "",
                mobilePhone: null,
                phone: null,
                idIncomeGroup: "",
                isPac: false,
                isPolicy: false
            },
            typeCancelAuthorization: "",
            order: {
                id: "",
                status: "",
                number: "",
                deliveryAddress: "",
                orderType: {},
                deliveryDate: "",
                notApplyShippingFee: false
            },
            numbreThree: "",
            numberTwo: "",
            numberOne: "",
            nameNomenclature: "",
            nomenclature: [
                "Anillo",
                "Autopista",
                "Avenida",
                "Avenida Calle",
                "Avenida Carrera",
                "Calle",
                "Carrera",
                "Circular",
                "Diagonal",
                "Transversal",
                "Zona"
            ],
            observation: "",
            note: "",
            itemTypeOrder: [{
                    id: "EXCLUSIVE",
                    name: "Exclusivo"
                },
                {
                    id: "INTEGRATED",
                    name: "Integrado"
                }
            ],
            error: false,
            orderDetail: [],
            // Location selects
            states: [],
            cities: [],
            branches: [],
            scheduleRanges: [],
            location: {
                state: "",
                city: "",
                branch: "",
                scheduleRange: ""
            },
            listMedicine: [],
            patientListData: [],
            documentTypeItems: [],
            createReminder: false,
            addM: false,
            time: 2000,
            snackbar: false,
            showGrid: false,
            showGridAppointment: false,
            dataMedicines: [],
            cancelReason: "",
            headers: [{
                    sortable: true,
                    text: "Orden",
                    value: "orderCode",
                    align: "left"
                },
                {
                    sortable: false,
                    text: i18n.t("headers.provider"),
                    value: "providerId",
                    align: "left"
                },
                {
                    sortable: false,
                    text: "Valor cuota moderadora",
                    value: "scaleFee",
                    align: "left"
                },
                {
                    sortable: false,
                    text: "Número de entrega",
                    value: "deliveryNumber",
                    align: "left"
                },
                {
                    sortable: false,
                    text: "Acciones",
                    value: "actions",
                    align: "left",
                    name: "actions"
                }
            ],
            typeCancelOrder: [],
            typeCancelAuthorization: [],
            daysOfWeek: [],
            selectedScheduleRange: "",
            showOrderNumber: false,
            isNewOrder: true,
            money: {
                decimal: ".",
                thousands: ",",
                precision: 0,
                masked: false
            },
            attachments: [],
            disableSaveButton: false,
            SCHEDULED_ORDER_STATUS: "SCHEDULED",
            incomeGroupItems: [],
            lastCitySelected: "",
            dontApplyShippingFee: false,
            user: "",
            searchButtonLoading: false,
            fechaAllowed: "",
            maxDate: "",
            nameDissabled: false,
            searchIdentification: "",
            availableDates: null,
            searchIdentificationType: "",
            holidays: [],
            cellphoneEnable: false,
            phoneEnable: false,
            disableShippingFee: false,
            typePropertys: ['-Tipo de inmueble-', 'Casa', 'Edificio', 'Hotel', 'Oficina', 'Urbanización'],
            typeProperty: "",
            blockOrInteriors: ['-Bloque o interior-', 'Manzana', 'Zona', 'Bloque', 'Habitación', 'Apartamento', 'Piso'],
            blockOrInterior: "",
            observationOne: "",
            observationTwo: "",
            isPrioritizedPatient: false,
            validMedicine: [],
            validateBrach: true,
            maxDatePreviewDelivery: "",
            disableBranches: true,
            attachmentURL: '',
            showDownloadAttachment: false,
            isUnifiedPharmacy: false,
            forceShippingFee: [],
            addressFromSura: '',
            orderFromSura: false,
            // isPAC: false,
            //hasPolicy: false,
            // isSpoiled: false,
            cancelReasonSpecialMedicine: '',
            URLAttachments: [],
            isMinDateLoaded: false,
            imagenessuportt: [],
            imagenmodalsupor: [],
            rowpage: 1,
            rowsPerPageItems: [5, 10, 15, 20],
            array: [],
            totalcampos: 0,

        }
    },

    created() {
        this.maxDatePreviewDelivery = dayjs(new Date()).format("YYYY-MM-DD")
        this.getProviders();
        this.getDocuments();
        this.order.orderType = this.itemTypeOrder[0];
        this.getIncomeGroups();
        this.getForceShippingFee()
        this.getCancelReasons();
    },
    mounted() {
        this.getHolidays();
        this.getUserName();
    },
    watch: {
        paginationn: {
            handler() {
                console.log("esteee es uno")
                    // this.listhistory();
            },
            deep: true
        }
    },
    methods: {
        async listsupport() {
            try {
                if (this.order.id) {
                    const response = await serviceForceShippingFee.support(this.order.id);
                    this.imagenessuportt = response.data;
                }
            } catch (error) {
                console.log("error de consulta soportes", error)
            }
        },
        async listhistory() {
            if (this.order.id) {
                const { page, rowsPerPage } = this.paginationn;
                console.log("esteee es dos ", this.paginationn)
                this.array = [];
                this.campos = [];

                console.log("esteee es tres ", this.paginationn)
                try {
                    if (this.paginationn.rowsPerPage == undefined) {
                        this.paginationn.rowsPerPage = 5
                    }

                    const response = await serviceForceShippingFee.gethistory(
                        page * 1,
                        rowsPerPage, this.order.id);
                    console.log(response.data);
                    this.campos = response.data[0]
                    this.totalcampos = response.data[1]
                    this.array = this.campos.map(x => {
                        x.Motivo = x.Motivo;
                        x.estado = x.estado;
                        if (x.estado == 'RETURNED') {
                            x.estado = 'DEVUELTO'
                        } else if (x.estado == 'SCHEDULED') {
                            x.estado = 'AGENDADO'
                        } else if (x.estado == 'CANCELED') {
                            x.estado = 'CANCELADO'
                        } else if (x.estado == 'CHECKED_IN') {
                            x.estado = 'EMPACADO'
                        } else if (x.estado == 'CHECKED_OUT') {
                            x.estado = 'DISTRIBUCIÓN'
                        } else if (x.estado == 'DELIVERED') {
                            x.estado = 'ENTREGADO'
                        }
                        x.fecha_hora = x.fecha_hora.slice(0, 10);
                        x.RowNum = x.RowNum;
                        x.orden = x.orden;
                        return x
                    })
                    console.log("holaa", this.array)

                } catch (error) {
                    console.log("error historico estados", error)
                }
            }
        },
        clickimagen(imagen) {
            this.imagenn = true;
            this.imagenmodalsupor = imagen
            const arrFront = new Uint8Array(imagen.data.data);
            let typeString = "";
            console.log("x1 user", imagen);
            switch (imagen.fileType) {
                case "jpg":
                    typeString = "image/jpeg";
                    break;
                case "jpeg":
                    typeString = "image/jpeg";
                    break;
                case "png":
                    typeString = "image/png";
                    break;
                case "pdf":
                    typeString = "application/pdf";
                    break;
                default:
                    break;
            }
            const blobFront = new Blob([arrFront], { type: typeString });
            let fileURLFront = window.URL.createObjectURL(blobFront);
            this.imagenmodalsupor = {
                fileName: imagen.fileName,
                imageFront: fileURLFront,
            };
        },
        closed() {
            this.imagenn = false;
        },
        async download(url) {
            const xhr = new XMLHttpRequest();
            xhr.responseType = "blob";
            xhr.onload = () => {
                var urlCreator = window.URL || window.webkitURL;
                var imageUrl = urlCreator.createObjectURL(xhr.response);
                const link = document.createElement("a");
                link.href = imageUrl;
                link.setAttribute("download", this.imagenmodalsupor.fileName);
                link.setAttribute("target", "new");
                document.body.appendChild(link);
                link.click();
            };
            xhr.open("GET", url);
            xhr.send();
            console.log('downloading', url);
        },

        async getForceShippingFee() {
            try {
                let response = await serviceForceShippingFee.forceShippingFeeAll();
                if (response.data.code === 'No data available') {
                    this.forceShippingFee = []
                } else {
                    this.forceShippingFee = response.data.map(data => data.idCity)
                }
            } catch (error) {
                console.log(error)
            }
        },
        async getUserId() {
            let userId = await StorageService.getUserData().id;
            if (!userId || typeof userId === 'string') {
                if (this.userInfo) {
                    userId = this.userInfo.id
                }
                userId = 0
            }
            return userId
        },

        async getProviderIds(orderDetails) {
            let providerIds = []
            orderDetails.map(orderDetail => {
                providerIds.push(orderDetail.providerId)
            })
            return providerIds;
        },

        getUserName() {
            const user = StorageService.getUserData();
            this.user = user.name;
        },
        contains(arr, id) {
            return arr.some(e => e.id === id);
        },
        getDefaultProviderId() {
            const hasOrderDetails = this.orderDetail.length > 0;
            let providerId = -1;

            if (
                hasOrderDetails &&
                this.order.orderType &&
                this.order.orderType !== ""
            ) {
                if (this.order.orderType === this.itemTypeOrder[0].id) {
                    // let detailStatus = this.orderDetail.find(od => od.medicines.find(m => m.check === true))
                    let medicine = this.dataMedicines.find(medicine => medicine.check === true)
                    if (medicine === undefined) {
                        providerId = this.dataMedicines[0].providerId;
                    } else {
                        providerId = medicine.providerId
                    }
                } else {
                    providerId = StorageService.getIntegratedProvider();
                }
            }

            return providerId;
        },
        getDocuments() {
            serviceDocument.getDocuments().then(response => {
                this.documentTypeItems = response.data;
            });
        },
        getIncomeGroups() {
            incomeGroupService.getAll().then(response => {
                this.incomeGroupItems = response.data;
            });
        },
        async getStates(order) {
            let providersAux = []
            this.dataMedicines.forEach(medicine => {
                if (medicine.check === true) {
                    if (!providersAux.includes(medicine.providerName)) {
                        providersAux.push(medicine.providerName);
                    }
                }
            })
            const moreThanOneProvider = providersAux.length > 1;

            let type = !moreThanOneProvider ?
                this.itemTypeOrder[0].id :
                this.itemTypeOrder[1].id

            const providerId = this.getDefaultProviderId();

            let response = await locationService.getStatesByProvider(1, type, providerId)
            this.states = response.data;
            if (!this.contains(this.states, this.location.state)) {
                if (!this.isNewOrder && order) {
                    this.states.push({
                        id: order.idCity.idState.id,
                        name: order.idCity.idState.name
                    })
                } else {
                    this.location.state = "";
                }
            }
            if (!this.contains(this.cities, this.location.city)) {
                this.location.city = "";
            }
            if (!this.contains(this.branches, this.location.branch)) {
                this.location.branch = "";
            }
            if (!this.contains(this.scheduleRanges, this.location.scheduleRange)) {
                this.location.scheduleRange = "";
            }
            if (this.states.length === 0) {
                this.showNoCoverageForAnyCity("warning");
                console.log("Entro citis 3");
            }
        },
        async getCities(order) {
            if (!this.location.state) return;

            let providersAux = []
            this.dataMedicines.forEach(medicine => {
                if (medicine.check === true) {
                    if (!providersAux.includes(medicine.providerName)) {
                        providersAux.push(medicine.providerName);
                    }
                }
            })
            const moreThanOneProvider = providersAux.length > 1;

            let type = !moreThanOneProvider ?
                this.itemTypeOrder[0].id :
                this.itemTypeOrder[1].id

            const providerId = this.getDefaultProviderId();

            let response = await locationService
                .getCitiesByProvider(this.location.state, type, providerId)
            this.cities = response.data
            this.cities = this.cities.map(c => c.idCity)
            if (!this.contains(this.cities, this.location.city)) {
                if (!this.isNewOrder && order) {
                    this.cities.push({
                        id: order.idCity.id,
                        name: order.idCity.name
                    })
                } else {
                    this.location.city = "";
                }
            }
            if (!this.contains(this.branches, this.location.branch)) {
                this.location.branch = "";
            }
            if (!this.contains(this.scheduleRanges, this.location.scheduleRange)) {
                this.location.scheduleRange = "";
            }
            if (this.cities.length === 0) {
                this.showNoCoverageForAnyCity("warning");
                console.log("Entro citis 2");
            }
        },
        async getBranches(order) {
            try {

                if (!this.location.city) return;
                this.disableBranches = true
                if (this.lastCitySelected != this.location.city) {
                    this.lastCitySelected = this.location.city;
                    this.location.scheduleRange = "";
                    this.location.branch = 0
                    this.scheduleRanges = [];
                }

                const providerId = this.getDefaultProviderId();
                let response;
                if (this.isUnifiedPharmacy) {
                    response = await locationService.getBranchesForUnifiedPharmacy(this.location.city)
                } else {

                    if (!order) {
                        response = await locationService.getBranchesByCityProviderAndType(
                            this.location.city,
                            providerId,
                            this.order.orderType,
                            this.location.branch
                        );
                    } else {
                        response = order.idProviderScheduleRange ? await locationService.getBranchesByCityProviderAndType(
                            this.location.city,
                            providerId,
                            this.order.orderType,
                            this.location.branch
                        ) : await locationService.getBranchesByCityProviderAndTypePolicy(
                            this.location.city,
                            providerId,
                            this.order.orderType,
                            this.location.branch
                        );
                    }



                    // response = await locationService.getBranchesByCityProviderAndType(
                    //     this.location.city,
                    //     providerId,
                    //     this.order.orderType,
                    //     this.location.branch
                    // )
                }
                this.branches = response.data;


                if (!this.isNewOrder && order) {
                    if (!this.branches.length > 0) this.branches = []
                    if (!this.contains(this.branches, this.location.branch)) {
                        this.branches.unshift({
                            id: this.location.branch,
                            active: true,
                            branchCities: [{
                                active: true,
                                idCity: {
                                    id: order.idCity.id,
                                    name: order.idCity.name
                                }
                            }]
                        })
                    }
                }

                let dta = []

                if (this.branches && this.branches.length > 0) {
                    for (let b of this.branches) {
                        for (let bc of b.branchCities) {

                            if (parseInt(bc.idCity.id) === parseInt(this.location.city) && bc.active === true) {
                                dta.push(b)
                                break;
                            }
                        }
                    }
                    console.log("data ya", dta[0]);
                    if (dta[0].idUnifiedPharmacy !== null && dta[0].idUnifiedPharmacy !== undefined) {
                        const response3 = await locationService.getBranchesForUnifiedPharmacy(this.location.city)
                        this.location.branch = response3.data[0].id
                    } else {
                        this.location.branch = dta[0].id;
                    }

                    if (!this.isNewOrder && order) {
                        await this.getScheduleRanges(order);
                    } else {
                        this.location.scheduleRange = "";
                        await this.getScheduleRanges();
                    }
                } else {
                    this.showNoCoverageForAnyCity("warning");
                }
            } catch (error) {
                console.log("error >>", error);
                this.$notify({
                    group: "app",
                    type: "error",
                    text: "Ha habido un problema consultando los municipios"
                })
            }
        },
        async getScheduleRanges(order) {
            try {
                if (!this.location.branch) return;

                let response;
                if (!order) {
                    response = await locationService
                        .getScheduleRangesByBranch(this.location.branch);
                } else {
                    response = order.idProviderScheduleRange ? await locationService
                        .getScheduleRangesByBranch(this.location.branch) : await locationService
                        .getScheduleRangesByPolicyBranch(this.location.branch);
                }


                // let response = await locationService
                //     .getScheduleRangesByBranch(this.location.branch);

                if (response.data.code === 'No data available') {

                    this.scheduleRanges = []
                } else {

                    if (response.data.length >= 1) {
                        // console.log("🚀 ~ getScheduleRanges ~ response.data:", response.data)
                        // console.log("🚀 ~ getScheduleRanges ~ this.location.city:", this.location.city)
                        this.scheduleRanges = response.data.filter(
                                sr => {
                                    if (sr.idBranchCity !== null) {
                                        return sr.idBranchCity.idCity.id === this.location.city

                                    }
                                }
                            )
                            //console.log("🚀 ~ getScheduleRanges ~ this.scheduleRanges:", this.scheduleRanges)
                    }
                    // else{
                    //     this.scheduleRanges = response.data;
                    // }

                }
                if (!this.isNewOrder && order) {
                    if (!this.contains(this.scheduleRanges, this.location.scheduleRange)) {
                        this.scheduleRanges.push(order.idProviderScheduleRange ? order.idProviderScheduleRange : order.idPolicyScheduleRange)
                    }
                }
                // if (this.isPrioritizedPatient && !this.contains(this.forceShippingFee, this.location.city)) {
                //   this.scheduleRanges.forEach(sr => (sr.shippingFee = 0));
                // }
                this.scheduleRanges.forEach(
                    sr =>
                    (sr.range = `${sr.idScheduleRange.start} - ${sr.idScheduleRange.end}`)
                );
                if (!this.contains(this.scheduleRanges, this.location.scheduleRange)) {
                    this.location.scheduleRange = "";
                }
                this.disableBranches = false
                this.getDate()
                this.$forceUpdate();
            } catch (error) {
                console.log("error franjas hoarioas", error);
                this.$notify({
                    group: "app",
                    type: "error",
                    text: "Ha habido un problema consultando las franjas horarias"
                })
            }

        },
        getProviders() {
            serviceProvider.getProviders().then(response => {
                const integratedProvider = StorageService.getIntegratedProvider();
                this.providerItems = response.data.filter(
                    item => item.id !== integratedProvider
                );


            });
            console.log("🚀 ~ serviceProvider.getProviders ~ this.providerItems:", this.providerItems)
        },
        onlyNumberAndLetters(e) {
            if (e.key.match(/[a-z0-9ñçáéíóú\s]/i) === null) {
                e.preventDefault();

            }
        },

        async changeSpoiled(isSpoiled) {
            this.isSpoiled = isSpoiled;
        },

        async test() {
            const formData = new FormData();
            formData.append("testFile", this.testFile);
            console.log("x1", formData)
        },

        async saveScheduling() {
            this.disableSaveButton = true;
            if (this.patientListData.length === 0) {
                this.$notify({
                    group: "app",
                    type: "error",
                    text: i18n.t("app.scheduling.error-no-patients")
                });
                this.disableSaveButton = false;
                return;
            }

            let noMobilePhone = false
            this.patientListData.forEach(p => {
                if (p.mobilePhone === '' || p.mobilePhone === null || p.mobilePhone === undefined) {
                    noMobilePhone = true
                }
            })
            if (noMobilePhone) {
                this.$notify({
                    group: "app",
                    type: "error",
                    text: "El celular es un campo requerido, por favor registrar para continuar"
                })
                this.disableSaveButton = false;
                return
            }

            let noPhone = false
            this.patientListData.forEach(p => {
                if (p.phone === '' || p.phone === null || p.phone === undefined) {
                    noPhone = true
                }
            })
            if (noPhone) {
                this.$notify({
                    group: "app",
                    type: "error",
                    text: "El telefono es un campo requerido, por favor registrar para continuar"
                });
                this.disableSaveButton = false;
                return
            }

            if (!this.orderDetail || this.orderDetail.length === 0) {
                this.$notify({
                    group: "app",
                    type: "error",
                    text: i18n.t("app.scheduling.error-no-order-details")
                });
                this.disableSaveButton = false;
                return;
            }
            if (!this.orderFromSura) {
                if (
                    this.nameNomenclature === '' ||
                    this.numberOne === '' ||
                    this.numberTwo === '' ||
                    this.numbreThree === '' ||
                    this.nameNomenclature === null ||
                    this.numberOne === null ||
                    this.numberTwo === null ||
                    this.numbreThree === null ||
                    this.nameNomenclature === undefined ||
                    this.numberOne === undefined ||
                    this.numberTwo === undefined ||
                    this.numbreThree === undefined
                ) {
                    this.$notify({
                        group: "app",
                        type: "error",
                        text: "Falta un campo en la dirección"
                    });
                    this.disableSaveButton = false;
                    return;
                }
            } else {
                if (
                    (this.nameNomenclature !== '' && this.nameNomenclature !== null && this.nameNomenclature !== undefined) ||
                    (this.numberOne !== '' && this.numberOne !== null && this.numberOne !== undefined) ||
                    (this.numberTwo !== '' && this.numberTwo !== null && this.numberTwo !== undefined) ||
                    (this.numbreThree !== '' && this.numbreThree !== null && this.numbreThree !== undefined)
                ) {
                    if (
                        this.nameNomenclature === '' ||
                        this.numberOne === '' ||
                        this.numberTwo === '' ||
                        this.numbreThree === '' ||
                        this.nameNomenclature === null ||
                        this.numberOne === null ||
                        this.numberTwo === null ||
                        this.numbreThree === null ||
                        this.nameNomenclature === undefined ||
                        this.numberOne === undefined ||
                        this.numberTwo === undefined ||
                        this.numbreThree === undefined
                    ) {
                        this.$notify({
                            group: "app",
                            type: "error",
                            text: "Falta un campo en la dirección"
                        });
                        this.disableSaveButton = false;
                        return;
                    }
                }
            }
            // let thereIsApplicableOrWatchedMedicines = false;
            // const allOrderDetailHasMedicines = this.orderDetail.reduce(
            //   (hasMedicines, orderDetails) => {
            //     orderDetails.medicines.forEach(m => {
            //       thereIsApplicableOrWatchedMedicines =
            //         thereIsApplicableOrWatchedMedicines || m.isApplicable;
            //       thereIsApplicableOrWatchedMedicines =
            //         thereIsApplicableOrWatchedMedicines || m.isWatched;
            //     });
            //     return hasMedicines && orderDetails.medicines.length > 0;
            //   },
            //   true
            // );

            // if (!allOrderDetailHasMedicines) {
            //   this.$notify({
            //     group: "app",
            //     type: "error",
            //     text: i18n.t("app.scheduling.error-no-medicines")
            //   });
            //   return;
            // }
            let count = 0
            for (const medicine of this.dataMedicines) {
                if (medicine.check === false) {
                    if (medicine.typeCancelAuthorization === '' || medicine.typeCancelAuthorization === null || medicine.typeCancelAuthorization === undefined) {
                        this.$notify({
                            group: "app",
                            type: "error",
                            text: `La autorización ${medicine.orderCode} se desea cancelar pero no tiene un motivo de cancelación asociado`
                        });
                        this.disableSaveButton = false;
                        return;
                    }
                    count++
                }
            }
            if (count === this.dataMedicines.length) {
                this.$notify({
                    group: "app",
                    type: "error",
                    text: 'El pedido debe tener al menos una autorización asociada.'
                });
                this.disableSaveButton = false;
                return;
            }

            for (const medicine of this.dataMedicines) {
                if (medicine.check === false) {
                    if (
                        medicine.typeCancelAuthorization === 'Previamente entregado' &&
                        (medicine.datePreviewDelivery === "" || medicine.datePreviewDelivery === null || medicine.datePreviewDelivery === undefined)
                    ) {
                        this.$notify({
                            group: "app",
                            type: "error",
                            text: i18n.t("ERROR_MOTIVO_CANCELACION_DATE")
                        });
                        this.disableSaveButton = false;
                        return;
                    }
                }
            }

            let providersAux = []
            this.dataMedicines.forEach(medicine => {
                if (medicine.check === true) {
                    if (!providersAux.includes(medicine.providerName)) {
                        providersAux.push(medicine.providerName);
                    }
                }
            })
            const moreThanOneProvider = providersAux.length > 1;

            if (moreThanOneProvider && this.order.orderType === "EXCLUSIVE") {
                this.$notify({
                    group: "app",
                    type: "error",
                    text: "El tipo de pedido no coincide con la información"
                });
                this.disableSaveButton = false;
                return;
            }

            if (!this.$refs.validFormOrder.validate()) {
                this.$notify({
                    group: "app",
                    type: "error",
                    text: i18n.t("app.scheduling.error-order-form")
                });
                this.disableSaveButton = false;
                return;
            }

            if (this.typeProperty === "-Tipo de inmueble-") {
                this.typeProperty = "";
            }
            if (this.blockOrInterior === "-Bloque o interior-") {
                this.blockOrInterior = "";

            }
            if (!this.orderFromSura) {
                this.order.deliveryAddress = `${this.nameNomenclature}  ${this.numberOne} # ${this.numberTwo} - ${this.numbreThree}`;
            } else {
                if (
                    (this.nameNomenclature !== '' && this.nameNomenclature !== null && this.nameNomenclature !== undefined)
                ) {
                    this.order.deliveryAddress = `${this.nameNomenclature}  ${this.numberOne} # ${this.numberTwo} - ${this.numbreThree}`;
                } else {
                    this.order.deliveryAddress = this.addressFromSura
                }
            }
            this.order.nameNomenclature = this.nameNomenclature;
            this.order.numberOne = this.numberOne;
            this.order.numberTwo = this.numberTwo;
            this.order.numbreThree = this.numbreThree;

            this.order.typeProperty = this.typeProperty;
            this.order.observationOne = this.observationOne;
            this.order.blockOrInterior = this.blockOrInterior;
            this.order.observationTwo = this.observationTwo;

            let userId = await this.getUserId();
            let providerIds = await this.getProviderIds(this.orderDetail);

            if (this.isPrioritizedPatient && !this.contains(this.forceShippingFee, this.location.city)) {
                this.order.notApplyShippingFee = true
            }
            /* if (this.contains(this.forceShippingFee, this.location.city)) {
               this.order.notApplyShippingFee = false
             }*/

            const providerId = this.getDefaultProviderId();

            let formData = {
                patients: this.patientListData,
                orderData: {
                    ...this.order,
                    orderDetail: this.orderDetail,
                    location: this.location,
                    medicinesList: this.dataMedicines,
                    typeUserOrder: this.isSpoiled ? 9 : null
                },
                note: this.note,
                observation: this.observation,
                createReminder: this.createReminder,
                userId: userId,
                providerIds: providerIds,
                provider: providerId
            };
            try {
                let responseScheduling = await serviceOrder.createOrder(formData)
                if (this.attachments.length > 0) {
                    if (this.attachments[0].size) {
                        let responseUpload = await serviceOrder.uploadAttachment(responseScheduling.data.id, this.attachments);
                    }
                }
                this.$refs.orderList.getOrders();
                this.showOrderNumber = this.order.id === "";
                this.snackbar = true;
                this.closeOrder(true);
                return
            } catch (error) {
                if (error.error === 'Order already scheduled') {
                    this.$notify({
                        group: "app",
                        type: "error",
                        text: "Alguna de las autorizaciones ya ha sido agenda, vuelva a consultar de nuevo las autorizaciones del paciente",
                        duration: 10000
                    });
                } else {
                    this.disableSaveButton = false;
                    this.$notify({
                        group: "app",
                        type: "error",
                        text: "Ha ocurrido un error al agendar el pedido"
                    });
                }
            }
        },

        postSaveSchedulingCanceled() {
            const items = this.dataMedicines
            if (this.order.id) {
                for (const item of items) {
                    let data = {}
                    if (item.check === false) {
                        data.orderCode = item.orderCode
                        data.canceled = item.typeCancelAuthorization
                        data.fecha = item.datePreviewDelivery
                        this.listMedicine.push(data);
                    }
                }

                if (this.listMedicine.length > 0) {
                    let listMedicine = {
                        list: this.listMedicine,
                        code: this.order.id
                    };
                    orderDetailsService
                        .deleteMedicine(listMedicine)
                        .then(result => {
                            if (result.data.statusCode === 200) {
                                this.$notify({
                                    group: "app",
                                    type: "warning",
                                    text: result.data.message
                                });
                            }
                            this.listMedicine = [];
                        })
                        .catch(error => {
                            console.error(error);
                        });
                }
            } else {
                for (const item of items) {
                    let data = {}
                    if (item.check === false) {
                        data.orderCode = item.orderCode
                        data.canceled = item.typeCancelAuthorization
                        data.fecha = item.datePreviewDelivery
                        this.listMedicine.push(data);
                    }
                }
                if (this.listMedicine.length > 0) {
                    let listMedicine = {
                        list: this.listMedicine,
                        code: this.order.number
                    };

                    orderDetailsService
                        .deleteMedicine(listMedicine)
                        .then(result => {
                            if (result.data.statusCode === 200) {
                                this.$notify({
                                    group: "app",
                                    type: "warning",
                                    text: result.data.message
                                });
                            }
                            this.listMedicine = [];
                        })
                        .catch(error => {
                            console.error(error);
                        });
                }
            }
        },
        deletePatient(document) {
            if (this.patientListData.length > 1) {
                this.patientListData = this.patientListData.filter(p => p.document !== document)
                this.dataMedicines = this.dataMedicines.filter(m => m.document !== document)
                this.orderDetail = this.orderDetail.filter(od => od.patientIdentification !== document)
                this.updateOrderType();
            }
        },

        validateOrderDetail() {
            let count = 0
            for (const medicine of this.dataMedicines) {
                if (medicine.check === false) {
                    count++
                }
            }
            if (count === this.dataMedicines.length) {
                this.$notify({
                    group: "app",
                    type: "error",
                    text: 'El pedido debe tener al menos una autorización asociada.'
                });
                this.disableSaveButton = true
                return;
            }
            this.disableSaveButton = false
            if (this.isNewOrder) {
                this.updateOrderType();
            }
        },
        savePhone(patient) {
            this.disabled(patient);

            this.patientListData[patient.index].mobilePhone =
                patient.item.mobilePhone;
            this.patientListData[patient.index].phone = patient.item.phone;
        },

        saveMobilePhone(patient) {
            this.disabled(patient);


            this.patientListData[patient.index].mobilePhone =
                patient.item.mobilePhone;
            this.patientListData[patient.index].phone = patient.item.phone;
        },
        validateNumberCellphone(patient) {
            let disableSaveButton = false;

            if (patient.item.mobilePhone[0] == '' || patient.item.mobilePhone[0] == undefined) {
                disableSaveButton = true;
                this.$notify({
                    group: "app",
                    type: "error",
                    text: "El campo no puede estar vacio."
                });
            } else {
                if (patient.item.mobilePhone[0] != '3') {
                    disableSaveButton = true;
                    this.$notify({
                        group: "app",
                        type: "error",
                        text: "El número celular debe empezar con el número 3."
                    });
                }
                if (patient.item.mobilePhone.length < 10) {
                    disableSaveButton = true;
                    this.$notify({
                        group: "app",
                        type: "error",
                        text: "El número debe tener como minimo 10 caracteres."
                    });
                }
                if (patient.item.mobilePhone.length == 10) {
                    let count = 0;
                    for (let i = 0; i < patient.item.mobilePhone.length; i++) {
                        let numberInitial = patient.item.mobilePhone[1]

                        if (numberInitial == patient.item.mobilePhone[i]) {
                            count += 1;
                        }
                    }
                    if (count >= 8) {
                        disableSaveButton = true;
                        this.$notify({
                            group: "app",
                            type: "error",
                            text: "Número inválido."
                        });
                    }
                }
            }

            return disableSaveButton;

        },
        disabled(patient) {
            this.disableSaveButton = false;
            if (this.validateNumberCellphone(patient)) {
                // this.disableSaveButton = true;
            } else if (this.validateNumberphone(patient)) {
                // this.disableSaveButton = true;
            }
        },
        validateNumberphone(patient) {
            let disableSaveButton = false;
            if (patient.item.phone[0] == null || patient.item.phone[0] == undefined || patient.item.phone[0] == '') {
                disableSaveButton = true;
                this.$notify({
                    group: "app",
                    type: "error",
                    text: "El campo no puede estar vacio."
                });

            } else {
                if (patient.item.phone.length < 7) {
                    disableSaveButton = true;
                    this.$notify({
                        group: "app",
                        type: "error",
                        text: "El número debe tener como minimo 7 caracteres."
                    });
                }

                if (patient.item.phone.length >= 7) {
                    let count = 0;
                    for (let i = 0; i < patient.item.phone.length; i++) {
                        let numberInitial = patient.item.phone[0]
                        if (numberInitial == patient.item.phone[i]) {
                            count += 1;
                        }
                    }
                    if (count >= 6) {
                        disableSaveButton = true;
                        this.$notify({
                            group: "app",
                            type: "error",
                            text: "Número inválido."
                        });
                    }
                }
            }
            return disableSaveButton
        },
        addOrderDetail(validate, orderId, status) {
            if (!validate) {
                if (!this.orderDetail.some(od => od.orderCode === this.orderCode)) {
                    const newOrderDetail = {
                        id: orderId,
                        orderCode: this.orderCode,
                        // eslint-disable-next-line operator-linebreak
                        scaleFee: typeof this.scaleFee === "string" ?
                            parseFloat(this.scaleFee.replace(",", "")) : this.scaleFee,
                        deliveryNumber: this.deliveryNumber,
                        providerId: this.providerOD,
                        initialProvider: this.initialProvider,
                        providerName: this.providerItems.find(
                            p => p.id === this.providerOD
                        ).name,
                        status: status || "NO_STATUS",
                        paymentType: this.paymentType,
                        patientName: this.patientName,
                        patientIdentification: this.patientIdentification,
                        medicines: []
                    };
                    this.orderDetail.push(newOrderDetail);

                    // if (this.update === 0) {
                    //   this.updateOrderType();
                    // }
                    this.$emit("dataOrderDetail", this.orderDetail);
                }
            }
        },
        async updateOrderType() {
            let providersAux = []
            this.dataMedicines.forEach(medicine => {
                if (medicine.check === true) {
                    if (!providersAux.includes(medicine.providerName)) {
                        providersAux.push(medicine.providerName);
                    }
                }
            })
            const moreThanOneProvider = providersAux.length > 1;

            const oldOrderType = this.order.orderType;
            this.order.orderType = !moreThanOneProvider ?
                this.itemTypeOrder[0].id :
                this.itemTypeOrder[1].id;

            if (oldOrderType !== this.order.orderType) {
                await this.getStates();
                this.getCities();
                this.getBranches();
            }
        },
        assignMedicineToOrder(item) {
            this.addM = true;
            this.selectOrderCode = item.orderCode;

            const foundOrder = this.foundCurrentOrder(this.selectOrderCode);

            this.dataMedicines = foundOrder.medicines;
        },
        foundCurrentOrder(id) {
            return this.orderDetail.find(currentOrder => {
                return id === currentOrder.orderCode;
            });
        },
        closeOrder(reloadOrders) {
            this.$refs.validFormPatient.reset();
            if (this.$refs.validFormOrder) this.$refs.validFormOrder.reset();
            if (this.$refs.validFormNotes) this.$refs.validFormNotes.reset();
            if (this.$refs.attachButton) this.$refs.attachButton.clear();
            this.getCancelReasons()
            this.orderFromSura = false
            this.isPrioritizedPatient = false
            this.isFeatured = false;
            this.createReminder = false;
            this.order.id = "";
            this.patient.id = "";
            this.dataMedicines = [];
            this.orderDetail = [];
            this.dialog = false;
            this.showGrid = false;
            this.showGridAppointment = false;
            this.disableSaveButton = false;
            this.nameDissabled = false;
            this.authorizationsLoaded = false;
            if (reloadOrders) {
                this.$refs.orderList.getOrders();
            }
            this.patientListData = [];
            this.attachment = {
                name: ""
            };
            this.isNewOrder = true;
            this.listMedicine = [];
            this.daysOfWeek = [];
            this.holidays = [];
            this.cancelReason = "";
            this.datePreviewDelivery = ""
            this.validMedicine = []
            this.attachmentURL = ''
            this.URLAttachments = []
            this.showDownloadAttachment = false
            this.attachments = []
            this.isMinDateLoaded = false
        },
        addMedicines(validate, medicineId, medicineCondition) {
            if (!validate) {
                const foundOrder = this.foundCurrentOrder(this.selectOrderCode);
                this.isFeatured =
                    this.isFeatured ||
                    (medicineCondition ? medicineCondition.isFeatured : false);
                this.isApplicable =
                    this.isApplicable ||
                    (medicineCondition ? medicineCondition.isApplicable : false);
                this.isWatched =
                    this.isWatched ||
                    (medicineCondition ? medicineCondition.isWatched : false);
                const patientNameAux = this.order.id ? foundOrder.patientName : this.patient.fullname
                const patientIdentificationAux = this.order.id ? foundOrder.patientIdentification : this.patient.document
                    /**TODO: Llenado de Tabla */
                if (this.cancelReason !== "" && this.cancelReason !== null && this.cancelReason !== undefined) {
                    let cancelReasonInArray = this.typeCancelAuthorization.find(cr => cr.name === this.cancelReason)
                    if (!cancelReasonInArray) {
                        this.typeCancelAuthorization.push({
                            name: this.cancelReason
                        })
                    }
                }
                this.dataMedicines.push({
                    check: this.getCheckMedicine(
                        foundOrder.status,
                        medicineCondition ? medicineCondition.isApplicable : false,
                        medicineCondition ? medicineCondition.isWatched : false,
                        medicineCondition ? medicineCondition.isFeatured : false
                    ),
                    fullname: patientNameAux,
                    document: patientIdentificationAux,
                    id: medicineId,
                    plu: this.plu,
                    description: this.description,
                    count: this.count,
                    nextShippingDate: this.nextShippingDate,
                    orderCode: this.selectOrderCode,
                    providerName: foundOrder.initialProvider ? foundOrder.initialProvider.name : foundOrder.providerName,
                    providerId: foundOrder.initialProvider ? foundOrder.initialProvider.id : foundOrder.providerId,
                    scaleFee: foundOrder.scaleFee,
                    deliveryNumber: foundOrder.deliveryNumber,
                    status: foundOrder.status,
                    paymentType: foundOrder.paymentType,
                    isApplicable: medicineCondition ?
                        medicineCondition.isApplicable : false,
                    isWatched: medicineCondition ? medicineCondition.isWatched : false,
                    isFeatured: medicineCondition ? medicineCondition.isFeatured : false,
                    // typeCancelAuthorization: this.cancelReason,
                    typeCancelAuthorization: this.cancelReason === "" ?
                        this.getSelectedMedince(
                            medicineCondition ? medicineCondition.isApplicable : false,
                            medicineCondition ? medicineCondition.isWatched : false,
                            medicineCondition ? medicineCondition.isFeatured : false
                        ) : this.cancelReason,
                    datePreviewDelivery: this.datePreviewDelivery !== null ? this.datePreviewDelivery.split('T')[0] : '',
                    datePicker: false
                });

                foundOrder.medicines = this.dataMedicines.filter(
                    m => m.orderCode === this.selectOrderCode
                );

                if (foundOrder.status ||
                    foundOrder.status != 'NO_STATUS' ||
                    foundOrder.status != 'SCHEDULED') {
                    this.validateMedicine(this.dataMedicines)
                }

                if (this.isNewOrder) {
                    this.updateOrderType();
                }

                this.$emit("dataMedicines", this.dataMedicines);
            }
        },
        changeCancelReason(medicine) {
            if (medicine.typeCancelAuthorization === undefined) {
                this.dataMedicines.forEach((med) => {
                    if (med.orderCode === medicine.orderCode) {
                        med.check = true
                        med.typeCancelAuthorization = ''
                        med.datePreviewDelivery = ''
                    }
                });
                this.validateOrderDetail();
                return
            }
            let cancelReason = medicine.typeCancelAuthorization
            this.dataMedicines.forEach((med) => {
                if (med.orderCode === medicine.orderCode) {
                    med.check = false
                    if (cancelReason === 'Previamente entregado') {
                        med.datePreviewDelivery = medicine.datePreviewDelivery
                    } else {
                        med.datePreviewDelivery = ''
                    }
                    med.typeCancelAuthorization = cancelReason
                }
            })
            this.validateOrderDetail();
        },
        changeDatepreviewDelivery(medicine) {
            this.dataMedicines.forEach((med) => {
                if (med.orderCode === medicine.orderCode) {
                    med.datePreviewDelivery = medicine.datePreviewDelivery
                }
            })
        },
        getItemSelectedReason(reason) {
            let list = null;
            switch (reason) {
                case "Orden anulada":
                    list = this.typeCancelAuthorization[0];
                    break;
                case "Orden vencida":
                    list = this.typeCancelAuthorization[1];
                    break;
                case "Previamente entregado":
                    list = this.typeCancelAuthorization[2];
                    break;
                case "Solicitud del paciente":
                    list = this.typeCancelAuthorization[3];
                    break;
                case "Duplicidad":
                    list = this.typeCancelAuthorization[4];
                    break;
                case "El medicamento debe ser reclamado en farmacia":
                    list = this.typeCancelAuthorization[5];
                    break;
                case "Dirección Errada":
                    list = this.typeCancelAuthorization[6];
                    break;
                case "Tutela":
                    list = this.typeCancelAuthorization[7];
                    break;
                case "Zona sin cobertura":
                    list = this.typeCancelAuthorization[8];
                    break;
            }
            return list;
        },
        getCheckMedicine(status, isApplicable, isWatched, isFeatured) {
            let valide = true;
            if (status === "CANCELED") {
                valide = false;
            } else if (
                isApplicable === true ||
                isWatched === true ||
                isFeatured === true
            ) {
                valide = false;
            }
            return valide;
        },
        getSelectedMedince(isApplicable, isWatched, isFeatured) {
            let validStatus = false;
            if (isApplicable === true || isWatched === true || isFeatured === true) {
                validStatus = true;
            }
            if (validStatus === true) {
                return this.cancelReasonSpecialMedicine;
            }
        },

        validateMedicine(data) {
            for (const d of data) {
                if (!this.validMedicine.includes(d.orderCode) && d.isApplicable === true || d.isWatched === true || d.isFeatured === true) {
                    this.validMedicine.push(d.orderCode, d.typeCancelAuthorization)
                    if (d.typeCancelAuthorization === 'El medicamento debe ser reclamado en farmacia') {
                        d.status = 'CANCELED'
                    }
                }
                if (this.validMedicine.includes(d.orderCode)) {
                    if (d.typeCancelAuthorization === 'El medicamento debe ser reclamado en farmacia') {
                        d.status = 'CANCELED'
                    }
                }
                if (this.validMedicine.includes(d.orderCode) && d.isApplicable === false && d.isWatched === false && d.isFeatured === false) {
                    d.check = false;
                    d.typeCancelAuthorization = 'El medicamento debe ser reclamado en farmacia';
                }
            }
        },

        async handleOrder(order) {
            console.log("entro en sheduling")
            this.loading = true
            if (order.id) {
                let user = JSON.parse(localStorage.getItem("user"));

                let response = await serviceOrder.getOrderWithId(order.id, true)
                order = response.data

                this.isNewOrder = false;
                if (
                    parseInt(StorageService.getUserData().rol) === 1005
                ) {
                    this.disableSaveButton = true;
                    this.nameDissabled = true;
                } else if (order.status !== "SCHEDULED") {
                    this.disableSaveButton = true;
                    this.nameDissabled = true;
                }
            }

            if (order.idSura) {
                this.orderFromSura = true
                this.addressFromSura = order.shippingAddress
            }

            let isItLoaded = false;
            // this.getAllowedDate();
            order.orderPatients.forEach(orderPatient => {
                let patient = orderPatient.idPatient;
                if (
                    this.patientListData.some(
                        p =>
                        p.documentType === patient.idIdentificationType.id &&
                        p.document === patient.identification
                    )
                ) {
                    isItLoaded = true;
                }
            });

            if (isItLoaded) return false;

            this.showGrid = true
            this.showGridAppointment = false

            // const userData = StorageService.getUserData()
            // if (order.status !== 'RETURNED' && order.status !== 'SCHEDULED') this.disableSaveButton = true

            this.order.deliveryAddress = '';
            this.nameNomenclature = '';
            this.numberOne = '';
            this.numberTwo = '';
            this.numbreThree = '';

            this.typeProperty = '';
            this.observationOne = '';
            this.blockOrInterior = '';
            this.observationTwo = '';

            if (order.id) {
                this.order.deliveryAddress = `${this.nameNomenclature}  ${this.numberOne} # ${this.numberTwo} - ${this.numbreThree}`;
                this.nameNomenclature = order.nameNomenclature;
                this.numberOne = order.numberOne;
                this.numberTwo = order.numberTwo;
                this.numbreThree = order.numbreThree;

                this.typeProperty = order.typeProperty;
                this.observationOne = order.observationOne;
                this.blockOrInterior = order.blockOrInterior;
                this.observationTwo = order.observationTwo;

            }

            this.createReminder = order.reminders && order.reminders.length > 0;
            this.order.id = order.id;
            this.order.status = order.status;
            if (order.type !== "NO_STATUS") {
                switch (order.type) {
                    case "EXCLUSIVE":
                        this.order.orderType = this.itemTypeOrder[0].id;
                        break;
                    case "INTEGRATED":
                        this.order.orderType = this.itemTypeOrder[1].id;
                        break;
                }
            }
            this.order.number = order.number;
            this.order.notApplyShippingFee = order.notApplyShippingFee;

            this.selectedScheduleRange = order.idProviderScheduleRange ?
                order.idProviderScheduleRange.id + "" :
                "";

            if (!this.authorizationsLoaded) {
                this.patientListData = [];
                this.orderDetail = [];
            }
            order.orderPatients.forEach(orderPatient => {
                let patient = orderPatient.idPatient;
                this.patientListData.push({
                    id: patient.id,
                    documentType: patient.idIdentificationType.id,
                    document: patient.identification,
                    fullname: patient.name,
                    address: patient.address,
                    mobilePhone: patient.mobilePhone,
                    phone: patient.phone,
                    idIncomeGroup: patient.idIncomeGroup ? patient.idIncomeGroup.id : "-",
                    isPac: +patient.PAC === 1,
                    isPolicy: +patient.policy === 1
                });
            });

            // this.patientListData.forEach(p => {
            //   if (p.mobilePhone == '' || p.mobilePhone == null || p.mobilePhone == undefined || p.phone == '' || p.phone == null || p.phone == undefined) {
            //     this.disableSaveButton = true;
            //   }
            // });

            let orderDetails = order.orderDetails;
            this.patient.document = order.idPatient.identification;
            this.patient.fullname = order.idPatient.name;

            this.searchIdentification = order.idPatient.identification;
            this.searchIdentificationType = order.idPatient.idIdentificationType.code;

            let response2 = await servicePatient.prioritizedPatient(
                this.searchIdentification,
                this.searchIdentificationType
            );
            let patient = response2.data;
            if (!patient.code) {
                // this.order.notApplyShippingFee = true
                // this.disableShippingFee = true
                this.isPrioritizedPatient = true
                    // this.isPAC = patient.isPAC
                    // this.hasPolicy = patient.hasPolicy
            }

            orderDetails.forEach(orderDetail => {
                this.orderCode = orderDetail.code;
                this.scaleFee = orderDetail.slidingScaleFee;
                this.deliveryNumber = orderDetail.number;
                this.paymentType = orderDetail.paymentType;
                this.patientName = orderDetail.patientName ? orderDetail.patientName : this.patient.fullname;
                this.patientIdentification = orderDetail.patientIdentification ? orderDetail.patientIdentification : this.patient.document;
                if (orderDetail.idProvider) {
                    this.providerOD = orderDetail.idProvider.id;
                }
                this.initialProvider = null
                if (orderDetail.initialProvider) {
                    this.initialProvider = orderDetail.initialProvider;
                }

                this.addOrderDetail(false, orderDetail.id, orderDetail.status);
                if (order.id) {
                    this.cancelReason = orderDetail.cancelReason;
                    this.datePreviewDelivery = orderDetail.date_PreviewDelivered;
                }

                if (orderDetail.orderDetailMedicines) {
                    orderDetail.orderDetailMedicines.forEach(medicine => {
                        this.plu = medicine.pluCode;
                        this.description = medicine.description;
                        this.count = medicine.quantity;
                        this.nextShippingDate = medicine.nextShippingDate;
                        this.selectOrderCode = orderDetail.code;
                        this.addMedicines(false, medicine.id, medicine.idMedicineCondition);
                    });
                }
                if (this.isNewOrder) {
                    this.updateOrderType();
                }
            });

            this.isUnifiedPharmacy = false
            if (order.idCity) {

                // if (order.idProviderScheduleRange.idBranch.idProvider.name === 'FARMACIA UNIFICADA') {
                //     this.isUnifiedPharmacy = true
                // }

                this.location.branch = order.idProviderScheduleRange ? order.idProviderScheduleRange.idBranch.id : order.idPolicyScheduleRange.idBranch.id;
                this.location.city = order.idCity.id;
                this.lastCitySelected = order.idCity.id;
                this.location.state = order.idCity.idState.id;
                await this.getBranches(order);
                await this.getStates(order);

                this.location.branch = order.idProviderScheduleRange ? order.idProviderScheduleRange.idBranch.id : order.idPolicyScheduleRange.idBranch.id;
                this.location.city = order.idCity.id;
                this.lastCitySelected = order.idCity.id;
                this.location.state = order.idCity.idState.id;
                await this.getCities(order);

                this.location.scheduleRange = order.idProviderScheduleRange ? order.idProviderScheduleRange.id : order.idPolicyScheduleRange.id;

            } else {
                this.location.scheduleRange = "";
                this.location.branch = "";
                this.location.city = "";
                this.location.state = "";
                await this.getStates();
            }
            console.log("entro en sheduling 6", this.location.city)
            if (order.id) {
                // this.getDate();
                this.order.deliveryDate = order.shippingDate;
            }

            if (order.id) {
                this.attachments = []
                for (let i = 0; i < order.attachments.length; i++) {
                    const attachment = order.attachments[i];
                    const arr = new Uint8Array(attachment.data.data);
                    const blob = new Blob([arr], { type: 'application/pdf' });
                    let fileURL = window.URL.createObjectURL(blob);
                    this.URLAttachments.push(fileURL)
                    this.attachments.push({ name: attachment.fileName })
                }
                this.showDownloadAttachment = true
            }

            this.observation = ''
            if (order.id) {
                this.observation = order.observation
            }

            this.note = order.note;

            this.authorizationsLoaded = true;
            this.listsupport();
            this.listhistory();
            this.patient = {};
            this.loading = false
            return true;
        },
        showAttachment(index) {
            window.open(this.URLAttachments[index]);
        },
        async cancelOrder() {
            if (this.checked === "") {
                this.$notify({
                    group: "app",
                    type: "error",
                    text: "Por favor escoga un motivo cancelación."
                });
                return;
            }
            if (
                this.checked === 'Previamente entregado' &&
                this.date_previewDelivered === ""
            ) {
                this.$notify({
                    group: "app",
                    type: "error",
                    text: "Por favor escoga la fecha Entrega."
                });
                return;
            }

            if (this.checked !== 'Previamente entregado') {
                this.date_previewDelivered = "";
            }

            const user = JSON.parse(localStorage.getItem("user"));
            let userId = await this.getUserId();
            let data = {
                order: this.order.id,
                provider: user["providerId"],
                motivo_cancelacion: this.checked,
                fecha_entrega: this.date_previewDelivered,
                user: StorageService.getUserData(),
                userId: userId
            };
            serviceOrder
                .cancelOrder(data)
                .then(res => {
                    this.date_previewDelivered = "";
                    this.checked = false;
                    this.closeOrder(true);
                })
                .catch(error => {
                    console.error(error);
                });
            this.dialog = false;
        },
        getCancelReasons() {

            serviceOrder.getTypeAuthorizationOrder().then(result => {
                // this.listhistory();
                this.typeCancelAuthorization = result.data
                this.cancelReasonSpecialMedicine = this.typeCancelAuthorization.find(cr => cr.name === 'El medicamento debe ser reclamado en farmacia').name
            });
            serviceOrder.getTypePedidoOrder().then(result => this.typeCancelOrder = result.data);
        },
        searchAuthorizations() {
            if (this.$refs.validFormPatient.validate()) {
                this.searchButtonLoading = true;
                this.searchIdentification = this.patient.document;
                this.searchIdentificationType = this.patient.documentType;

                let user = JSON.parse(localStorage.getItem("user"));

                if (user.branchType === "EXCLUSIVE") {
                    serviceOrder
                        .getAuthorizationsWithProvider(
                            this.patient.documentType,
                            this.patient.document,
                            user.providerId
                        )
                        .then(response => {
                            console.log("🚀 ~ searchAuthorizations ~ response.data:", response.data)
                            this.authorizationsLoaded = this.handleOrder(response.data);

                            console.log("holla ajohanna j 1")
                                //this.listsupport();
                                // this.listhistory();
                            this.searchButtonLoading = false;
                            // this.getAllowedDate();
                            // this.getDate();
                        })
                        .catch(() => {
                            this.searchButtonLoading = false;
                            this.$notify({
                                group: "app",
                                type: "error",
                                text: "No se han encontrado autorizaciones para el paciente especificado."
                            });
                        });
                } else {
                    serviceOrder
                        .getAuthorizations(this.patient.documentType, this.patient.document)
                        .then(response => {
                            this.authorizationsLoaded = this.handleOrder(response.data);
                            console.log("holla ajohanna j 2")
                                //this.listsupport();
                                // this.listhistory();
                            this.searchButtonLoading = false;
                            // this.getAllowedDate();
                            // this.getDate();
                        })
                        .catch(() => {
                            this.searchButtonLoading = false;

                            this.$notify({
                                group: "app",
                                type: "error",
                                text: "No se han encontrado autorizaciones para el paciente especificado."
                            });
                        });
                }
            }
        },
        getHolidays() {
            let today = new Date();
            let holidaysAux = holidaysApi.getColombiaHolidaysByYear(
                today.getFullYear()
            );
            for (let i = 0; i < holidaysAux.length; i++) {
                const holiday = holidaysAux[i];
                const input = holiday.holiday.split("-");
                let dateAux = new Date(input[0], input[1] - 1, input[2]);
                this.holidays.push(dayjs(dateAux).format());
            }
        },
        getDate() {
            if (this.location.branch !== '') {
                serviceCalendar
                    .getAllowedDates(this.location.branch, this.isSpoiled)
                    .then(result => {
                        if (result.data.length === 0) {
                            this.$notify({
                                group: "app",
                                type: "warning",
                                text: 'No hay configuración de calendario para la sede'
                            });
                        } else {
                            this.daysOfWeek = result.data;
                            this.maxDate = dayjs(result.data[5]).format("YYYY-MM-DD");
                            this.fechaAllowed = dayjs(result.data[0]).format("YYYY-MM-DD");
                            if (!this.order.id) {
                                this.order.deliveryDate = this.fechaAllowed;
                            }
                            this.isMinDateLoaded = true
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    });
            }
        },
        formatDate(date) {
            let day = date.getDate();
            let month = date.getMonth() + 1;
            let year = date.getFullYear();
            let zeroInDay = day.toString().length > 1 ? day : `0${day}`;
            let zeroInMonth = month.toString().length > 1 ? month : `0${month}`;
            return `${year}-${zeroInMonth}-${zeroInDay}`;
        },
        getAllowedDate() {
            let today = new Date();
            let addedDays = today.getHours() < 13 ? 2 : 3;

            if (
                this.order.orderType === "EXCLUSIVE" &&
                this.orderDetail[0].providerId == 3
            ) {
                addedDays++;
            }

            let sundaysOrHolidays = 0;
            for (let i = 0; i <= addedDays; i++) {
                let checkDate = dayjs(
                    new Date(today.getFullYear(), today.getMonth(), today.getDate() + i)
                );
                if (
                    this.holidays.find(date => dayjs(date).isSame(checkDate)) ||
                    checkDate.day() === 0
                ) {
                    sundaysOrHolidays++;
                }
            }

            let auxDate = new Date(
                today.getFullYear(),
                today.getMonth(),
                today.getDate() + addedDays + sundaysOrHolidays
            );

            if (auxDate.getDay() === 0) {
                let nextMonday = new Date(
                    auxDate.getFullYear(),
                    auxDate.getMonth(),
                    auxDate.getDate() + 1
                );
                if (this.holidays.find(date => dayjs(date).isSame(nextMonday))) {
                    this.minDate = new Date(
                        auxDate.getFullYear(),
                        auxDate.getMonth(),
                        auxDate.getDate() + 2
                    );
                } else {
                    this.minDate = nextMonday;
                }
            } else if (this.holidays.find(date => dayjs(date).isSame(auxDate))) {
                this.minDate = new Date(
                    auxDate.getFullYear(),
                    auxDate.getMonth(),
                    auxDate.getDate() + 1
                );
            } else {
                this.minDate = auxDate;
            }

            this.maxDate = dayjs(
                new Date(today.getFullYear(), today.getMonth(), today.getDate() + 10)
            ).format("YYYY-MM-DD");
            this.fechaAllowed = dayjs(this.minDate).format("YYYY-MM-DD");
            this.order.deliveryDate = this.fechaAllowed;
        },

        allowedDates(val) {
            for (var i = 0; i < this.daysOfWeek.length; i++) {
                if (this.daysOfWeek[i] == val) {
                    return val;
                }
            }
        },

        openFileChooser() {
            this.$refs.file.click();
        },
        handleFile() {
            for (let i = 0; i < this.$refs.file.files.length; i++) {
                const file = this.$refs.file.files[i];
                console.log("x1 f", file)
                if (file.size && file.size > 2 * 1024 * 1024) {
                    // > 2MB
                    this.$notify({
                        group: "app",
                        type: "error",
                        text: i18n.t("app.scheduling.error-file-size")
                    });
                    this.attachments = []
                    return;
                }
            }
            this.attachments = this.$refs.file.files;
        },

        showNoCoverageForAnyCity(type) {
            this.$notify({
                group: "app",
                type,
                text: i18n.t("app.scheduling.no-coverage-area")
            });
        }
    },
    computed: {
        ...mapState('auth', ['userInfo']),
        isCityDisabled() {
            return this.location.state === "";
        },
        isBranchDisabled() {
            return this.location.city === "";
        },
        isScheduleRangeDisabled() {
            return this.location.branch === "";
        },
        notes: {
            get() {

                let ordersForFee = this.dataMedicines
                    .filter(m => m.check)
                    .map(item => {
                        return { code: item.orderCode, fee: item.scaleFee }
                    })

                ordersForFee = Array.from(new Set(ordersForFee.map(a => a.code)))
                    .map(code => {
                        return ordersForFee.find(a => a.code === code)
                    })

                let slidingScaleFeeTotal = ordersForFee
                    .map(item => item.fee)
                    .reduce((a, b) => a + +b, 0);

                let scheduleRange = {};

                if (this.location && this.location.scheduleRange) {
                    scheduleRange = this.scheduleRanges.find(
                        scheduleRange => scheduleRange.id === this.location.scheduleRange
                    );
                }

                let shippingFee =
                    scheduleRange && scheduleRange.shippingFee ?
                    scheduleRange.shippingFee :
                    0;

                if (this.order.notApplyShippingFee) {
                    shippingFee = 0;
                }
                let recoveryFeeText = "";
                let ordersForRecoveryFee = this.dataMedicines
                    .filter(m => m.check && m.paymentType === 'CUOTA DE RECUPERACION')

                ordersForRecoveryFee = Array.from(new Set(ordersForRecoveryFee.map(a => a.orderCode)))

                if (ordersForRecoveryFee.length > 0) {
                    recoveryFeeText =
                        "Además, debido a cuota de recuperación, se le cobrará el 10% del valor de los medicamentos de la orden:\n";
                    ordersForRecoveryFee.map(item => (recoveryFeeText += `- ${item}\n`));
                }

                let medicineText =
                    this.dataMedicines && this.dataMedicines.length > 0 ?
                    this.dataMedicines
                    .map(medicine => {
                        if (medicine.check === true) {
                            return `- ${medicine.count} de ${medicine.description}\n`;
                        } else {
                            return ""
                        }
                    }) : [];
                medicineText = medicineText.join("")
                return (
                    `Su domicilio queda programado para el día ${this.order.deliveryDate ? this.order.deliveryDate : " "
          } ` +
                    `en el horario ${scheduleRange && scheduleRange.range ? scheduleRange.range : " "
          }, ` +
                    `los medicamentos que entregaremos serán:\n\n ${medicineText}\n` +
                    `El valor de la cuota moderadora será máximo ${slidingScaleFeeTotal ? slidingScaleFeeTotal : "0"
          }. ` +
                    `${recoveryFeeText}` +
                    "Podría ser un valor inferior de acuerdo al precio del medicamento. " +
                    `El valor del envío es ${shippingFee}. ` +
                    `Para un total de ${slidingScaleFeeTotal + shippingFee}. ` +
                    "Como el domicilio queda programado, los medicamentos ya no podrán ser entregados en la farmacia. " +
                    "Recuerde esperar al mensajero con documento original o copia del mismo y el valor en efectivo para el pago. " +
                    "¡Que tenga un feliz día!"
                );
            },
            // set(notes) {
            //   this.notes = notes;
            // }
        }
    }
};